export default function navElements(routes) {
  return routes.filter((route) => route.meta && route.meta.isOnNavigation).sort((a, b) => a.meta.order - b.meta.order)
}
